import {PModuleType} from '@/enums/configs';
import {DtcpAcceleromerModuleAxisType, SpectrumIntervalAggregateType} from '@/enums/diagrams';
import {WaterfallTaskStatus} from '@/views/services/vibrationDiagnostic/enums';

/*
Словарь для получения алиасов измерений модулей
*/

export const measurementAliasPModule: Map<
  PModuleType,
  {main: string; compared: string[]}
> = new Map<PModuleType, {main: string; compared: string[]}>([
  [PModuleType.DtcpTahoModule, {main: 'mean', compared: []}],
  [PModuleType.CrmModule, {main: 'mean', compared: []}],
  [PModuleType.DtcpAccelerometerModule, {main: 'vel_x', compared: ['vel_y', 'vel_z']}],
]);

/*
  Список типов агрегации для графика водопада спектров
*/

export const spectrumIntervalAggregateTypes: {
  value: SpectrumIntervalAggregateType;
  name: string;
}[] = [
  {
    value: SpectrumIntervalAggregateType.Avg,
    name: 'Среднее',
  },
  {
    value: SpectrumIntervalAggregateType.Max,
    name: 'Максимум',
  },
];

/*
  Список типов осей для 3-х осного спектра
*/

export const dtcpAccelerometerAxisTypes: {
  value: DtcpAcceleromerModuleAxisType;
  name: string;
}[] = [
  {
    value: DtcpAcceleromerModuleAxisType.X,
    name: 'X',
  },
  {
    value: DtcpAcceleromerModuleAxisType.Y,
    name: 'Y',
  },
  {
    value: DtcpAcceleromerModuleAxisType.Z,
    name: 'Z',
  },
];

/*
Список статусов выполнения задачи получения данных для диаграммы водопада спектра
*/
export const waterfallTaskStatusList: {
  value: WaterfallTaskStatus;
  name: string;
}[] = [
  {
    value: WaterfallTaskStatus.NotRunning,
    name: 'Не запущен',
  },
  {
    value: WaterfallTaskStatus.Running,
    name: 'Выполняется',
  },
  {
    value: WaterfallTaskStatus.Completed,
    name: 'Завершен',
  },
  {
    value: WaterfallTaskStatus.Cancelled,
    name: 'Отменен',
  },
  {
    value: WaterfallTaskStatus.Deleted,
    name: 'Удален',
  },
];
